import { MessageCircle } from 'lucide-react';
import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../services/authentication/authContext';
import { canAccessSupportPage } from '../../services/accessManagement/accessManagement';
import { useSupportIdentity, useSupportStore } from '../../stores/appSupportStore';

export function SupportUnreadBadge() {
  const { t } = useTranslation('support');
  const identity = useSupportIdentity();
  const count = useSupportStore(state => state.identity === identity ? state.unreadCount : 0);
  if (!count) return null;
  return <span aria-label={t('unreadLabel', { count })} className="rounded-lg bg-darkGreenColor dark:bg-darkGreenColor-dark text-white dark:text-white px-2 py-0.5 text-xs font-bold tabular-nums">
    {count}
  </span>;
}

export function SupportNavLink({ className, activeClassName = '', onClick }: { className: string; activeClassName?: string; onClick?: () => void }) {
  const { t } = useTranslation('support');
  const { backendUser } = useAuth();
  if (!canAccessSupportPage(backendUser)) return null;
  return <NavLink to="/support" onClick={onClick} className={({ isActive }) => `${className} ${isActive ? activeClassName : ''}`}>
    <MessageCircle className="w-6 h-6 shrink-0" aria-hidden="true" />
    {t('navLabel')}
    <SupportUnreadBadge />
  </NavLink>;
}
